// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 216) return "static/chunks/vendors-d90d910c661d84d5.js";
	if (chunkId === 24) return "static/chunks/antd-fb6763c6e4baa345.js";
	if (chunkId === 351) return "static/chunks/commons-085a20cfd160ccbc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"38":"bbd26b58f98c8f09","60":"773b865136a2cc2d","141":"ba022cfe56383aac","182":"1c09b9d065eb6423","208":"3bd47cb7544cbe63","470":"5bc0feec357a67a7","496":"9a0a61b06073beca","523":"8c1e4802158870f2","617":"d67582d965744326","884":"84e8219abbda26fe"}[chunkId] + ".js";
};